/**
* In Edit Parent function is used to edit the parent profile and it's functions declare this file
**/
import {useParams ,useNavigate,Link} from 'react-router-dom';
import {useState,useEffect} from 'react';
import * as Yup from 'yup';
import { validate,findDuplicateIndices } from './../../../services/ValidationService';
import ApiService from './../../../services/ApiService';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { toast } from 'react-toastify';
import ImageCroper from './../../../shared/modals/ImageCroper'
import { dataURItoBlob,convertS3privateToPublic,filterGeoLocation ,goBack,getCountryCodeFromDialCode} from './../../../services/UtilsService';
import Autocomplete from 'react-google-autocomplete';
import constantVariables from './../../../dataset/constantVariables.json';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

function EditParent(){
	//Intial variable declaration
	const {id}=useParams();
	const [tab,setTab]=useState(0);
	const [data,setData]=useState({});	
	const [organization,setOrganization]=useState([{hospital:'',physician:''}]);
	const [physicianInfo,setPhysicianInfo]=useState([]);	
	const [dublicateInfo,setDublicateInfo]=useState([]);	
	const [list,setList]=useState({});
	//const [members,setMembers]=useState({});
	const [phyMembers,setPhyMembers]=useState({});
	console.log("Menber : ",phyMembers);
    const [errorOrg,setErrorOrg]=useState({});	
	const [error,setError]=useState({});
	const [valid,setValid]=useState(true);	
	const navigate =useNavigate();
	const [show,SetShow]=useState(false);
	const [image, setImage] = useState('');
	const [cropImge, setCropImage] = useState();
	const { t } = useTranslation();
	
	//callback function
	const handleClose = () => {
		SetShow(false);
		// Reset the file input value
		const fileInput = document.getElementById('file-6');
		if (fileInput) {
		  fileInput.value = ""; // Clear the file input so the same file can be selected again
		}
	  };
	const imageData= (data)=> setCropImage(data)
	
	//validate patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
	//components initialize function and api handling
	useEffect(()=>{
		if(id){
			(async()=>{			
				var response = await ApiService.getParent(id);
				if(response.status===200)
				 setData(response.data.parentInfo);
				 if(response.data.physicianInfo.length)
				 setPhysicianInfo(response.data.physicianInfo);
			     if(response.data.organizationInfo.length)
			     setOrganization(response.data.organizationInfo);
				console.log("Organization : ",organization);
			     var list = await ApiService.getUsersList({list:['physician','hospital']});
				 //var member = await ApiService.organizationMembers();
				 var physicianMappedOrg = await ApiService.physicianMembers();
				 if (list.status === 200) {
					// Get the hospital from the organization
					if(response.data.organizationInfo?.[0]?.hospital){
					const hospitalFromOrganization = response.data.organizationInfo?.[0]?.hospital;
	
					// Filter physicians based on the hospital
					const filteredPhysicians = list.data.physician.filter((physician) => {
						return (
							physician.hospital === hospitalFromOrganization ||
							physician.hospital === null ||
							physician.hospital === ''
						);
					});
	
					// Combine the filtered physicians and original hospitals into the list
					const filteredList = {
						physician: filteredPhysicians,
						hospital: list.data.hospital,
					};
	
					console.log("Filtered List : ", filteredList);
					setList(filteredList); // Set the filtered list
				}else
				{
					setList(list.data);
				}
				}
	
				console.log("List : ",list.data);
				 //if(member.status===200)
			     //setMembers(member.data?.items);
				 if (physicianMappedOrg.status === 200) {
					// Get the hospital from the organization
					if(response.data.organizationInfo?.[0]?.hospital){
					const hospitalFromOrganization = response.data.organizationInfo?.[0]?.hospital;
	
					// Filter physician members based on the hospital
					const filteredMembers = physicianMappedOrg.data?.items.filter((member) => {
						return (
							member.hospital.includes(hospitalFromOrganization) ||
							member.hospital.length === 0
						);
					});
	
					console.log("Filtered Members : ", filteredMembers);
					setPhyMembers(filteredMembers); // Set the filtered physician members
					}else
					{
						setPhyMembers(physicianMappedOrg.data?.items);
					}
				}				
			})();
		}	
	},[id]);
	
	/** 
	* Validation schema for Parent Fields
	* @first_name - required field and pass the parent first_name
	* @last_name - required field and pass the parent last_name
	* @members - required field and pass the parent members
	* @email - required field and should be in correct parent email format 
	* @mobileNumber - required field and pass the parent mobileNumber
	* @city - required field and pass the parent city 
	* @state - required field and pass the parent state
	* @gender - required field and pass the parent gender
	* @zipcode - required field and pass the parent zipcode
	**/
    const fields = [
		{ name: 'first_name', validation: Yup.string().trim().required(t('error.required')) },
		{ name: 'last_name', validation: Yup.string().trim().required(t('error.required')) },
		{ 
		name: 'members', 
		validation: Yup.string()
			.matches(/^\d+$/, t('error.numberFormat'))
			.required(t('error.required')) 
		},
		{ 
		name: 'email', 
		validation: Yup.string()
			.email(t('error.email')) // built-in email validation
			.required(t('error.emailRequired')) 
		},
		{ name: 'mobileNumber', validation: Yup.string()},
		{ name: 'city', validation: Yup.string().nullable()},
		{ name: 'state', validation: Yup.string().nullable()},
		{ name: 'gender', validation: Yup.string() },
		{
		name: 'zipcode',
		validation: Yup.string()
			.nullable() // Allows the field to be nullable
			.matches(/^[a-zA-Z0-9]+$/,t('error.zipcodeAlpha')) // Allows empty or valid number format
		//   .test('len', constantVariables.error.zipcode, function (value) {
		// 	return !value || value.length >= 5; // Only check length if value is not empty
		//   })
		},
    ];
	
   /** 
   * Organizationl Validation schema
   * @physician - required field and pass the selected physician name
   * @hospital - required field and pass the selected hospital name
   **/
   /*const phyFields=[
     { name: 'physician', validation: Yup.string().required(t('error.required')) },
	 { name: 'hospital' }
   ];*/
   
   const phyFields=[
     { name: 'orgInfo', validation: Yup.array().of(
		Yup.object({
		  physician: Yup.string().required(t('error.required')),
		  hospital: Yup.string().notRequired(),
		})) 
	 },
   ];
	
  /** To handle input change event 
  * @e - we get the event details from the Change action 
  **/
	 const handleChange=async(e)=>{
		 e.preventDefault();
		 const {name ,value}=e.target;
		 setData({...data,[name]:value});
		 const Errors = await validate({ [name]: value }, fields);
	     setError({...error,[name]:Errors[name]});
		 
	 };
	 
  /** 
  * To handle the image change
  * @e - we get the event details from the input file select action
  **/
  const handleFile=async (e)=>{
	  e.preventDefault();
	  const file = e.target.files[0];
	  openCropModal(file);

  }
  
  /** 
  * To open the image crop modal
  * @file - we pass the image details in the base 64 bit format
  **/
  const openCropModal=async(file)=>{
	  
	  if(file){
		 let ext = file.name.split('.').pop();
		 let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
		 if (!allowedExtensions.includes(ext)) {
				toast.error(t("error.fileFormat"));
				await SetShow(false);
				 return;
			}
		if (file.size > 100 * 1024 * 1024) {
			toast.error(t('error.fileSize'));
				await SetShow(false);
				 return;
		}
		 const reader = new FileReader();
		 reader.onload = () => { setImage(reader.result) };
		 reader.readAsDataURL(file);
		 await SetShow(true);
	 }else{
		 await SetShow(false);
	 }
  }
  
  /** 
  * To handle event drag
  * @e - we get the event details from the drag over action
  **/
  const handleDrag=(e)=>{
	  e.preventDefault();
  }
  
  /** 
  * To handle event drop
  * @e - we get the event details from the drop over action
  **/
  const handleDrop=(e)=>{
	  e.preventDefault();
	   const { files } = e.dataTransfer;
	   openCropModal(files[0]);
  }

  useEffect(() => {
	console.log("error : ",error);
}, [error]); // This will run whenever hospitalInfo changes
	 
	 /** 
	 * To handle the form submit
	 * @e - we get the event details from the form submit action
	 **/
	 const handleSubmit=async(e)=>{
		  e.preventDefault();
		  data.gender=(data.gender || data.gender===0 || data.gender===1 ) ? data.gender:'';
		  data.mobileNumber=data.mobileNumber||'';
		  if(!data.countryNameCode && data.mobileNumber && data.mobileNumber!==''){
			  data.countryNameCode=await getCountryCodeFromDialCode(data.countryCode+data.mobileNumber);
		  }

		// Validate organization information (hospital and physician)
  		const organizationErrors = {};
  		organization.forEach((item, index) => {
    	if (!item.hospital || item.hospital === '') {
      		organizationErrors[`orgInfo[${index}].hospital`] = "Hospital is required";
    	}
    	if (!item.physician || item.physician === '') {
      		organizationErrors[`orgInfo[${index}].physician`] = "Physician is required";
    	}
  		});

		  const tab1 = await validate(data, fields);
		  if(Object.keys(tab1).length || !valid){
			  setError(tab1);
			  console.log("error : ",error);
			  setTab(0);
			  return;
		  }

		  const tab2 = await validate({'orgInfo':organization}, phyFields);
		  // Merge both errors together
		  const combinedErrors = { ...organizationErrors, ...tab2 };
		  
		  
		  if(Object.keys(combinedErrors).length || dublicateInfo.length>0){
			setErrorOrg(combinedErrors); // Now setting both error sources
			  return;
		  }else{
			  
			  var filter=organization.map((item)=>{
			   return {hospital:item.hospital === null ? "" : item.hospital,parent:id,physician:item.physician}
		      });
			  var req={};
			  data.gender=(data.gender || data.gender===0 || data.gender===1 ) && data.gender!==''  ? data.gender:null;
			  req.parentInfo=data;
			  req.organizationInfo=filter;
			  req.parentInfo.id=id;
			  var response = await ApiService.updateParent(req);
			  if(response.status===200){
				 if (cropImge !== undefined) {
					const formData = new FormData();
					const fileConvertData =await dataURItoBlob(cropImge);
					formData.append('file', fileConvertData);
					await ApiService.uploadNewPhoto(id,formData);
				}  
				toast.success(response?.data?.message);
				navigate('/admin/parents'); 
			  }else{
				  toast.error(response?.data?.error[0]?.message||'Something went wrong');
			  }
		  }
	 }
	 
  /** 
  * To check phone number valid or not 
  * @value - we pass the actual phone number
  * @country - we pass the countryCode
  * @e - we get the event details from the onChange action
  * @formattedValue - we pass the country formatted Value
  **/
  const handlePhone= async(value, country, e, formattedValue) => {
      const {format, dialCode} = country;
	  setData({...data,countryCode:'+'+dialCode,mobileNumberWithCode:formattedValue,[e.target.name]:formattedValue.split("+"+dialCode+" ")[1],countryNameCode:country?.countryCode});
      const Errors = await validate({ [e.target.name]: formattedValue }, fields);
      setError({...error,[e.target.name]:Errors[e.target.name]});
	  
      if (!formattedValue || (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value)))) {
	       setValid(true);
	  }else{
		   setValid(false);
	  }
  }
  
  /** 
  * To add organization Info
  * @index - we pass the index value of the UI select
  * @e - we get the event details from the click action
  **/
  const addOrganization=(index)=>async(e)=>{
	  e.preventDefault();
	    const Errors = await validate({'orgInfo':organization}, phyFields); 
	    setErrorOrg(Errors);
	   if(Object.values(Errors).length ===0 && dublicateInfo.length===0){
	    setOrganization(state => [...state, {hospital:'',physician:''}]);
		const Errors = await validate({'orgInfo': [{ physician: '', hospital: '' }] }, phyFields);
		await setErrorOrg(Object.keys(Errors).reduce((acc, key) => ({ ...acc, [key.replace(/\[0\]/g, `[${index + 1}]`)]: Errors[key] }), {}));
	  }
  };
   
   /** 
  * To remove organization Info
  * @index - we pass the index value of the UI select
  * @e - we get the event details from the click action
  **/
  const removeOrganization=(index)=>async(e)=>{
	  e.preventDefault();
	  if(organization.length !==1){
	    var removeArr=organization.filter((i,idx)=> idx !==index);
	    setOrganization(removeArr);
		if((await findDuplicateIndices(removeArr,'physician','hospital')).length>0){
			const duplicateIndices = await findDuplicateIndices(removeArr,'physician','hospital');
			duplicateIndices.shift();
			await setDublicateInfo(duplicateIndices);
		  }else{
			await setDublicateInfo([]);  
		  }
	  }else{
		 setOrganization([{hospital:'',physician:''}]);
	  };
	   setErrorOrg({});
	  
  }
  
  /** 
  * To handle the organization change
  * @index - we pass the index value of the UI select
  * @e - we get the event details form the change action
  **/
  const changeOrgInfo=(index)=>async(e)=>{
	  //e.preventDefault();
	  const { name,value } = e.target;
	  const updateArr = organization.map((item, i) => {
		  if(name === 'physician'){
			if (index === i) {
				return { ...item, [name]: value , 'hospital':'' };
			} else {
				return item;
			 }	
			// Update physician without resetting the hospital
			//return { ...item, [name]: value };
		  } else if(name === 'hospital'){
			  if (index === i) {
				return { ...item, [name]: value };
			} else {
				return item;
			 }
			 // Update hospital
			 //return { ...item, [name]: value };
		  }
		   return item;		  
	  });
	  
	  const finalArr =updateArr.map((item, i) => {
		  if(item.hospital === ''){
			  return { ...item,hospital:null };
		  }
		  return item;
	  });
	  const Errors = await validate({'orgInfo': finalArr }, phyFields);
	  await setErrorOrg(Errors);
	  await setOrganization(finalArr);  
	  if((await findDuplicateIndices(finalArr,'physician','hospital')).length>0){
		const duplicateIndices = await findDuplicateIndices(finalArr,'physician','hospital');
		duplicateIndices.shift();
		await setDublicateInfo(duplicateIndices);
	  }else{
		await setDublicateInfo([]);  
	  }
  };
  
  
  /** To go to next page 
  * @e - we get the event details from the click action
  **/
  const goNext=async(e)=>{
	   e.preventDefault();
	   data.gender=(data.gender || data.gender===0 || data.gender===1 ) ? data.gender:'';
	   data.city=data.city ? data.city:'';
	   data.state=data.state ? data.state:'';
	   data.zipcode=data.zipcode ? data.zipcode:null;
	   data.mobileNumber=data.mobileNumber||'';
	   const Errors = await validate(data, fields);
	    setError(Errors);
	    if(!Object.keys(Errors).length && valid){
			setTab(1);
		}
  };
  
  /** 
  * To change city input 
  * @e - we get the event details form the change action
  **/
  const changeCity=async(e)=>{
         const { value }=e.target;
		 var obj={};
		 if(value.trim().length ===0){
			 obj={city:'',state:''};
		 }else{
		     obj={city:value};
		 }
		 setData((data)=>({...data,...obj}));
		 const Errors = await validate({ city:value }, fields);
	     setError({...error,city:Errors['city']});
  }
  
  /** 
  * To select city input 
  * @e - we get the event details from the Select action
  **/
  const selectCity=async(e)=>{ 
	     var location= await filterGeoLocation(e);
		   await setData((data)=>({...data,...location}));
  }
  
	return (
	<main id="main" className="main">
	 {/*import ImageCroper*/}
	<ImageCroper 
		show={show} 
		handleClose={handleClose}
		image={image}
		cropImge={imageData}
	/>
	{/*Page Title Section*/}
	<div className="pagetitle clearfix">
		<div className="float-start">
		  <h1>{t('profile.editParentInfo')}</h1>
			<nav>
				<ol className="breadcrumb">
				  <li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar.home')}</Link></li>
				  <li className="breadcrumb-item"><Link to='/admin/parents'>{t('sidebar.parents')}</Link></li>
				  <li className="breadcrumb-item active">{t('profile.editParentInfo')}</li>
				</ol>
			</nav>
		</div>
		<div className="float-end mt-2 me-1">
			<span onClick={goBack}  className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
		</div>
	</div>
	{/*End Page Title Section*/}
	
	{/*Page Content Section*/}
	<section>
	<div className="row">
		{/*ProfileImg*/}	
		<div className="col-xxl-3">
			<div className="card profile-img">
				<div className="card-body">
					<div className="upload-box d-none d-lg-block">		
						<div className="box text-center" onDrop = {handleDrop} onDragOver = {handleDrag}>
							<input type="file" onChange={handleFile} name="file-6" id="file-6" className="inputfile inputfile-4"  />
							<label htmlFor="file-6">
							{cropImge && (<img  className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />)}
							{(!cropImge && data && data?.photo && data?.photo ==='default.png') && <img className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" alt="IMG" />}
							{(!cropImge && data && data?.photo && data?.photo !=='default.png') && <img src={convertS3privateToPublic(data?.photo)} className="img-fluid d-block mx-auto" alt="IMG"  />}
								<span>{t('common.editChange')} <br /> ({t('common.dragDrop')})</span>
							</label>
						</div>
					</div>
					<div className="text-center text-tmBlue mt-4">
						<h6>{t('profile.uploadPicture')}</h6>
					</div>
				</div>
			</div>
		</div>
		
		{/*Parent Info*/}	
		<div className="col-xxl-9">
			<div className="card form-card profile-info ">
				<div className="card-body pt-4">
					<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
					  <li className="nav-item" role="presentation">
							<span onClick={()=>setTab(0)} className={tab===0?"nav-link active":"nav-link"}  type="button" role="tab" >{t('profile.parentInfo')}</span>
					 </li>
					  
					  <li className="nav-item" role="presentation">
							<span onClick={()=>setTab(1)} className={tab===1?"nav-link active":"nav-link"}  type="button" role="tab" >{t('profile.physicianInfo')}</span>
					 </li>
					 <li className="nav-item" role="presentation">
							<span onClick={()=>setTab(2)} className={tab===2?"nav-link active":"nav-link"}  type="button" role="tab" >{t('profile.hospitalInfo')}</span>
					 </li>
					  
					</ul>
					<div className="tab-content" >							
						{/*TAB-01*/}	
						{tab===0 && <div>
							<form autoComplete="off">
								<div className="row">
									<div className="col-lg-5 col-md-6">
										<div className=" form-group">
											<label>{t('profile.firstName')} </label>
											<input name="first_name" value={data.first_name?data.first_name.trim():''} onChange={handleChange} type="text" className="form-control" placeholder={t('profile.firstName')} />
												{error && error.first_name && <span className="required">{error.first_name}</span>}
										</div>
									</div>
									<div className="col-lg-5 col-md-6">
										<div className=" form-group">
											<label>{t('profile.lastName')} </label>
											<input name="last_name" value={data.last_name?data.last_name.trim():''} onChange={handleChange} type="text" className="form-control" placeholder={t('profile.lastName')} />
												{error && error.last_name && <span className="required">{error.last_name}</span>}
										</div>
									</div>
									<div className="col-lg-2 col-md-6">
										<div className=" form-group">
											<label>{t('profile.familyMember')}</label>
											<input name="members" maxLength={2} value={data.members?data.members:''} onChange={handleChange} type="text" className="form-control" placeholder={t('common.example2')} />
											{error && error.members && <span className="required">{error.members}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.phoneNumber')}</label>
											<PhoneInput 
												  inputProps={{
                                                  name: 'mobileNumber',
												  style: { width: '100%'}}}
												  value={data?.mobileNumberWithCode?data?.mobileNumberWithCode:''}
												  country={'us'}  
                                                   onChange={handlePhone}
												/>
											{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
											{!valid && !error.mobileNumber && <span className="required">{t('common.validNumber')}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.emailAddress')}</label>
											<input  name="email" onChange={handleChange} type="text" value={data.email?data.email:''} className="form-control" placeholder="youremail@mail.com" />
											{error && error.email && <span className="required">{error.email}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.relation')}</label>
											<select name="gender" value={data.gender!==null?data.gender:''} onChange={handleChange} className="form-select">
												<option value='' disabled>{t('common.relation')}</option>
											<option value="0">{t('profile.father')}</option>
											<option value="1" >{t('profile.mother')}</option>
											</select>
											{error && error.gender && <span className="required">{error.gender}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.addressOne')}</label>
											<input name="address_one" onChange={handleChange} type="text" value={data.address_one?data.address_one:''} className="form-control" placeholder={t('common.addressLine1')} />
											{error && error.address_one && <span className="required">{error.address_one}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.addressTwo')}</label>
											<input name="address_two" onChange={handleChange} type="text" value={data.address_two?data.address_two:''} className="form-control" placeholder={t('common.addressLine2')} />
											{error && error.address_two && <span className="required">{error.address_two}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.city')} </label>
											<Autocomplete
											value={data?.city?data.city:''}
											className="form-control" 
											placeholder={t('common.city')}
											onChange={changeCity}
											 onPlaceSelected={selectCity}
											types={['(cities)']}		
											/>
											{error && error.city && <span className="required">{error.city}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.state')} </label>
											<input name="state" onChange={handleChange} type="text" readOnly value={data.state?data.state:''} className="form-control" placeholder={t('common.state')} />
											{error && error.state && !data.state && <span className="required">{error.state}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.zipCode')} </label>
											<input name="zipcode" onChange={handleChange} type="text" value={data.zipcode?data.zipcode:''} className="form-control" placeholder={t('common.zipCode')} />
											{error && error.zipcode && <span className="required">{error.zipcode}</span>}
										</div>
									</div>
								</div>
								{/*Prev-Next Button Section*/}
								<div className="row mt-3">								
									<div className="col-lg-12 text-end">
										<button  type="button" onClick={goNext} className="btn btn-tmBlue btnNext"><i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}</button>
									</div>
								</div>
							</form>
						</div>	}
						
						{/*TAB-02*/}
						{tab===1 && <div>
							<form>
								<div className="row">			
								{physicianInfo && physicianInfo.length !== 0 && Object.values(physicianInfo.reduce((acc, item) => {
									if (!acc[item.physician]) {
										acc[item.physician] = item;
										acc[item.physician].visitingDays = [];
									}
									if (item.days && item.days.length > 0) {
										acc[item.physician].visitingDays.push({
											day: item.days,  // Keep the days as an array
											startTime: item.startTime,
											endTime: item.endTime,
										});
									}
									return acc;
								}, {})).map((item, i) => (
									<div key={i} className="col-lg-12">
										<div className="form-group row">	<div className="col-lg-6 col-md-6 mb-3">
												<label>{t('profile.hospitalName')} </label>
												<input readOnly name="hospital"value={item?.hospitalname || '--'} type="text" className="form-control" />
											</div>									
											<div className="col-lg-6 col-md-6 mb-3">
												<label>{t('sidebar.physician')} </label>
												<input readOnly name="physician"value={item?.physicianname || '--'} type="text" className="form-control" />
											</div>
											<div className="row">
												<div className="col-xxl-12">
													<div className="secTitle">
														<h1>{t('table.appointmentSettings')}</h1>
													</div>
												</div>
											</div>
											<div className="col-lg-3 col-md-6 mb-3">
												<label>{t('profile.consultingDuration')}</label>
												<input readOnly name="physician" value={item?.consultingDuration === null ? '--' : `${item?.consultingDuration} Mins`}  type="text" className="form-control" />
											</div>						
											<div className="col-lg-6 col-md-6 mb-3">
												<label>{t('profile.timeZone')} </label>
												<input readOnly name="timeZone"value={item?.timeZone || '--'} type="text" className="form-control" />
											</div>					
											{/* Visiting Days */}
											{item.visitingDays.map((visitingDay, idx) => (
												<div key={idx} className="row mb-3">
													<div className="col-lg-7 col-md-9">
														{idx === 0 && <label>Visiting Days</label>}
														<div className="form-group mb-0 checkRadio-bg">
															{["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day, index) => (
																<div key={index} className="form-check form-check-inline">
																	<input
																		className="form-check-input days_Admin"
																		type="checkbox"
																		name="DaysOptions"
																		id={`DaysOptionsD${index + 1}`}
																		value={day}
																		checked={visitingDay?.day.includes(day)}  // Fixed condition
																		readOnly
																	/>
																	<label className="form-check-label" htmlFor={`DaysOptionsD${index + 1}`}>{day.slice(0, 2)}</label>
																</div>
															))}
														</div>
													</div>
												{/* Visiting Time */}
												<div className="col-lg-4 col-md-6">
													{idx === 0 && <label>Visiting Time</label>}
													<div className="d-flex mb-3">
														<div>
															<input
																readOnly
																value={visitingDay?.startTime}
																name="startTime"
																type="time"
																className="form-control"
															/>
														</div>
														<div className="my-2 mx-3"> To </div>
														<div>
															<input
																readOnly
																value={visitingDay?.endTime}
																name="endTime"
																type="time"
																className="form-control"
															/>
														</div>
													</div>
												</div>
											</div>
										))}
											{/* Out Of Office */}
											{item?.out_of_office && item.out_of_office.length > 0 ? (<div className="col-lg-12 col-md-12 mb-3">
												<div className="row mt-4">
													<div className="col-xxl-12">
														<div className="secTitle">
															<h1>{t('profile.outOfOffice')}</h1>
														</div>
													</div>
												</div>
													{item?.out_of_office && item.out_of_office.length > 0 && item.out_of_office.map((outOfOffice, index) => {
														const [startDate, endDate] = outOfOffice.replace('[', '').replace(']', '').split(',');
														return (
															<div key={index} className="d-flex flex-column mb-3">
																<div className="d-flex">
																	<div className="me-3 col-lg-2">
																		<label>Start Date</label>
																		<input readOnly type="date" className="form-control" value={startDate} />
																	</div>
																	<div className="me-3 col-lg-2">
																		<label>End Date</label>
																		<input readOnly type="date" className="form-control" value={endDate} />
																	</div>
																</div>
															</div>
														);
													})}
												</div> ) : null}
											</div>	
											{physicianInfo && physicianInfo.length > 1 && i !== Object.values(physicianInfo).length - 1 && <hr style={{ marginBottom: '2rem' }} />}
									</div>	))}
									{ physicianInfo &&physicianInfo.length ===0 && <h5 className="text-center"> {t('common.noRecord')} </h5>}
								</div>
								
								{/*Prev-Next Button Section*/}
								<div className="row mt-3">
									<div className="col-lg-12 text-end">
										<button onClick={()=>setTab(0)} type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
										<button onClick={()=>setTab(2)} type="button" className="btn btn-tmBlue btnNext"><i className="ri-arrow-right-line align-middle"></i> {t('profile.next')}</button>
								</div>
								</div>
							</form>
						</div>}
						
						{/*TAB-03*/}
						{tab===2 && <div>
								<form>
									<div className="row">													
										<div className="col-lg-12">
											{ organization && organization.length !==0 && organization.map((item,i)=>(<div key={i} className="form-group row">													
												<div className="col-lg-5 col-md-5 mb-3">
													<label>{t('sidebar.physician')}</label>
												<Select
													value={
														list?.physician
														.filter((option) => option.account === item?.physician)
														.map((option) => ({
															value: option.account,
															label: `${option.first_name} ${option.last_name}`,
														}))[0] || null
													}
													options={
														list?.physician?.map((option) => ({
														value: option.account,
														label: `${option.first_name} ${option.last_name}`,
														})) || []
													}
													onChange={(selectedOption) =>
														changeOrgInfo(i)({
														target: { name: "physician", value: selectedOption?.value },
														})
													}
													placeholder={t('common.selectPhysician')}
													classNamePrefix="react-select"
													/>
												{errorOrg && (errorOrg['orgInfo['+i+'].physician']) && 
												<span className="required">{(errorOrg['orgInfo['+i+'].physician'])}</span>}
												</div>
												<div className="col-lg-5 col-md-5 mb-3">
													<label>{t('profile.hospitalName')} </label>
													<select 
														value={item.hospital || ''} 
														name="hospital" 
														onChange={changeOrgInfo(i)} 
														className="form-select"
														>
														<option value='' disabled>{t('common.selectHospital')}</option>
														{phyMembers && phyMembers.length !== 0 && (() => {
															const uniqueHospitals = new Set();

															return phyMembers.map((m) =>
																m.physician === item.physician &&
                                                            m?.hospital?.map((p) =>
                                                                list?.hospital?.map((l) => {
                                                                if (l?.id === p && !uniqueHospitals.has(l.id)) {
                                                                    uniqueHospitals.add(l.id);
                                                                    return <option key={l.id} value={l.id}>{l.name}</option>;
                                                                }
                                                                return null;
                                                                })
															)
															);
														})()}
													</select>
												{errorOrg && (errorOrg[`orgInfo[${i}].hospital`]) && 
    											<span className="required">{errorOrg[`orgInfo[${i}].hospital`]}</span>
												}
												</div>
												<div className="col-lg-2 col-md-2 d-flex align-items-center">
												<label>&nbsp; </label>
												<button  onClick={removeOrganization(i)} type="button" className="btn btn-outline-danger py-2" ><i className="ri-close-fill"></i></button>
												{organization.length && organization.length-1=== i && <button onClick={addOrganization(i)} type="button" className="btn btn-outline-tmBlue py-2 mx-2 d-none" ><i className="ri-add-fill align-middle"></i></button>}
											</div>
											{dublicateInfo && dublicateInfo.includes(i) && <span className="required">{t('common.alreadyExist')}</span>}
											</div>	
											))}
										</div>	
									</div>	
									
									{/*Prev-Next Button Section*/}
									<div className="row">								
										<div className="col-lg-12 text-end">
											<button onClick={()=>setTab(1)} type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {t('profile.prev')}</button>
											<button onClick={handleSubmit} type="button" className="btn btn-tmBlue"><i className="ri-check-double-fill align-middle"></i> {t('profile.submit')}</button>
										</div>
									</div>
								</form>
						 </div>}
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
{/* End Page Content Section */}
	
</main>
	);
	
}





export default EditParent;